const fonts = {
  heading: '"Montserrat", sans-serif',
  body: '"Montserrat", sans-serif',
  tooltip: '"Montserrat", sans-serif',
  mono: '"Inconsolata", monospace',
}

export default fonts
